import OnlineAttendeeSPs from './OnlineAttendeeSPs'

export default OnlineAttendeeSPs
